export default __webpack_public_path__ + "9689372f815575bfbab4990b3beacf04.png";